module.exports = __webpack_public_path__ + "static/media/lea_img_03.f6747070.jpg";